Date.prototype.addSeconds = function(seconds) {
    this.setSeconds(this.getSeconds() + seconds);
    return this;
  };
  
  Date.prototype.addMinutes = function(minutes) {
    this.setMinutes(this.getMinutes() + minutes);
    return this;
  };
  
  Date.prototype.addHours = function(hours) {
    this.setHours(this.getHours() + hours);
    return this;
  };
  
  Date.prototype.addDays = function(days) {
    this.setDate(this.getDate() + days);
    return this;
  };
  
  Date.prototype.addWeeks = function(weeks) {
    this.addDays(weeks*7);
    return this;
  };
  
  Date.prototype.addMonths = function (months) {
    var dt = this.getDate();
    this.setMonth(this.getMonth() + months);
    var currDt = this.getDate();
    if (dt !== currDt) {  
      this.addDays(-currDt);
    }
    return this;
  };
  
  if (!Date.prototype.toUTC){
    Date.prototype.toUTC = function(){
        var utcOffset = this.getTimezoneOffset();
        var utcNow    = this.addMinutes(utcOffset);
        return utcNow;
    };
  }

  export default {
    uniqByKeepFirst(a, key) {
        let seen = new Set();
        return a.filter(item => {
          let k = key(item);
          return seen.has(k) ? false : seen.add(k);
        });
      },
      uniqByKeepLast(a, key) {
        return [
          ...new Map(
            a.map(x => [key(x), x])
          ).values()
        ]
      },
      clone(obj) {
        return JSON.parse(JSON.stringify(obj));
      },
      duplicateAndClone(arr, times) {
        if (!times) {
          times = 1;
        }
        let newArr = this.clone(arr);
        for (let i = 0; i < times; i++) {
          newArr = newArr.concat(this.clone(arr));
        }
        return this.clone(newArr);
      },
      convertDateToUTC(date) {
        const year = date.getFullYear();
        const month = date.getMonth();
        const day = date.getDate();
        const hours = date.getHours();
        const minutes = date.getMinutes();
        const seconds = date.getSeconds();
        
        // Crea una nuova data in UTC mantenendo le componenti originali
        const utcDate = new Date(Date.UTC(year, month, day, hours, minutes, seconds));
        return utcDate;
      },
      converters: {
        base64ToVersion: function(base64, sections = 3) {
            const values = [];
            const output = [];
    
            function populateLookups() {
                const keys = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
                for (let i = 0; i < 256; i++) {
                    output.push(('0' + i.toString(16)).slice(-2));
                    values.push(0);
                }
                for (let i = 0; i < 65; i++) {
                    values[keys.charCodeAt(i)] = i;
                }
            }
    
            function base64ToHex(txt) {
                if (output.length <= 0) populateLookups();
                const result = [];
                let v1, v2, v3, v4;
    
                for (let i = 0, len = txt.length; i < len; i += 4) {
                    v1 = values[txt.charCodeAt(i)];
                    v2 = values[txt.charCodeAt(i + 1)];
                    v3 = values[txt.charCodeAt(i + 2)];
                    v4 = values[txt.charCodeAt(i + 3)];
    
                    result.push(
                        output[(v1 << 2) | (v2 >> 4)],
                        output[((v2 & 15) << 4) | (v3 >> 2)],
                        output[((v3 & 3) << 6) | v4]
                    );
                }
    
                if (v4 === 64) result.splice(v3 === 64 ? -2 : -1);
    
                // Limita ai valori richiesti da `sections` e sostituisce NaN con 'x'
                const numbers = result
                    .slice(0, sections)
                    .map(hex => {
                        const num = parseInt(hex, 16);
                        return isNaN(num) ? 'x' : num;
                    });
    
                return numbers.join('.');
            }
    
            return base64ToHex(base64);
        },
    
        numberToVersion: function(value, sections = 3) {
            const parts = [];
            for (let i = 0; i < sections; i++) {
                parts.push((value >> (i * 8)) & 0xff);
            }
            parts.reverse();
            // Sostituisce NaN con 'x' (anche se improbabile in questo caso)
            return parts.map(num => (isNaN(num) ? 'x' : num)).join(".");
        }
      },

      remoteControlEnabled(appliance) {
        return appliance.status['remoteControl'] == 1 || appliance.status['remoteControl'] == 'ON';
      },

      cycleInProgress(appliance) {
        if(!appliance.connection_status) {
          return false;
        }
        if(appliance.type == 'OVEN') {
          return appliance.status['currStepCookingPhase']!=null && appliance.status['currStepCookingPhase'] != 0 && appliance.status['currStepCookingPhase'] != 'standby';
        }
        if(appliance.type == 'BLASTCHILLER') {
          return appliance.status['appliancePhase']!=null && appliance.status['appliancePhase'] != 0 && appliance.status['appliancePhase'] != 'standby';
        }
        if(appliance.type == 'DISHWASHER') {
          return appliance.status['cyclePhase'] != null && appliance.status['cyclePhase'] != 0 &&  appliance.status['cyclePhase'] != 'null';
        }
        return false;
      },

      firmwareUpdateAvailable(appliance) {
        return appliance.status['CBapplianceFWUpgradeStatus'] == 2;
      },
    
    

    }